'use strict';

angular.module('cacmModule', [
    'cacmEventModule',
    'cacmDataPointModule',
    'cacmFollowUpModule',
    'cacmControlModule',
	'cacmDynamicsAccountTransactionModule',
	'cacmConcurExpenseModule'
]);